// this is an 'action' actions belong to REDUX system
//  all actions MUST have a 'type'. The 'type' should be a text that describes something that happened
//  they may also have a payload (other data)
// REDUX docs say that the 'type' SHOULD be in the format of "todos/todoAdded" where 
// the first part is the feature or category that this action belongs to, 
// and the second part is the specific thing that happened.
// THIS CODE DOES NOT LOOKS LIKE IT HAS CONFORMED TO THAT CONVENTION.. UGH
// these look like what REDUX docs calls "action creators"

export const SHOW_MODAL = 'SHOW_MODAL'
export const HIDE_MODAL = 'HIDE_MODAL'
export const UPDATE_MODAL_PROPS = 'UPDATE_MODAL_PROPS'

export const showModal = (type, props) => {
  return {
    type: SHOW_MODAL,
    modalType: type,
    modalProps: props,
    visible: true // added 6/18/25 for B5 update
  }
}

export const updateModalProps = (field, props) => {
  return {
    type: UPDATE_MODAL_PROPS,
    field: field,
    props: props
  }
}

export const hideModal = () => {
  return {
    type: HIDE_MODAL,
    modalType: null,  // these added 6/18/25
    modalProps: {},  // these added 6/18/25
    visible: false  // these added 6/18/25
  }
}
